webpackJsonp([5],{

/***/ 1046:
/***/ (function(module, exports, __webpack_require__) {

var checkAndBuildOpts = __webpack_require__(5);
var LegendManager = __webpack_require__(1381);

var REQUIRED_OPTS = [
  'deepInsightsDashboard',
  'layerStyleCollection'
];

/**
 * Integration between embed view with cartodb.js and deep-insights.
 */
var F = function (opts) {
  checkAndBuildOpts(opts, REQUIRED_OPTS, this);

  this._getWidgets().each(function (m) {
    this._bindWidgetChanges(m);
  }, this);

  LegendManager.trackLegends(this._getLayers());
};

F.prototype._bindWidgetChanges = function (m) {
  // wait until the widget has the state from the url
  m.bind('change:hasInitialState', function (m) {
    m.bind('change:autoStyle', this._onWidgetAutoStyleChanged, this);

    // In order to trigger legend update, we wait until the cartocss from autostyle is applied
    if (m.isAutoStyle()) {
      if (!m.dataviewModel.layer.get('initialStyle')) {
        m.dataviewModel.layer.once('change:initialStyle', function () {
          this._onWidgetAutoStyleChanged(m);
        }, this);
      } else {
        this._onWidgetAutoStyleChanged(m);
      }
    }
  }, this);
};

F.prototype._onWidgetAutoStyleChanged = function (m) {
  var isAnyAutoStyleApplied = this._getWidgets().any(function (m) {
    return m.isAutoStyle();
  }, this);

  var isAutoStyleApplied = m.isAutoStyle();
  var layerId = m.dataviewModel.layer.id;
  var layerStyle;

  if (isAutoStyleApplied) {
    LegendManager.updateLegends(layerId);

    layerStyle = this._layerStyleCollection.findById(layerId);
    // setting this in order to restore initial style when disable autostyle
    if (m.dataviewModel.layer) {
      m.dataviewModel.layer.attributes.initialStyle = layerStyle.get('cartocss');
    }
  } else if (!isAnyAutoStyleApplied) {
    LegendManager.resetLegends(layerId);
  }
};

F.prototype._getLayer = function (m) {
  return this.visMap().getLayerById(m.id);
};

F.prototype._getLayers = function (m) {
  return this.visMap().layers;
};

F.prototype.visMap = function () {
  return this._vis().map;
};

F.prototype._getWidgets = function (m) {
  return this._deepInsightsDashboard._dashboard.widgets._widgetsCollection;
};

F.prototype._vis = function () {
  return this._deepInsightsDashboard.getMap();
};

module.exports = F;


/***/ }),

/***/ 1047:
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
module.exports = Backbone.Collection.extend({
  model: function (d, opts) {
    var attrs = {};
    attrs.id = d.id;
    if (d.options.tile_style) {
      attrs.cartocss = d.options.tile_style;
    }
    return new Backbone.Model(attrs);
  },

  resetByLayersData: function (data) {
    this.reset(data, {
      silent: true
    });
  },

  findById: function (id) {
    return this.findWhere({id: id});
  }
});


/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 136,
	"./af.js": 136,
	"./ar": 143,
	"./ar-dz": 137,
	"./ar-dz.js": 137,
	"./ar-kw": 138,
	"./ar-kw.js": 138,
	"./ar-ly": 139,
	"./ar-ly.js": 139,
	"./ar-ma": 140,
	"./ar-ma.js": 140,
	"./ar-sa": 141,
	"./ar-sa.js": 141,
	"./ar-tn": 142,
	"./ar-tn.js": 142,
	"./ar.js": 143,
	"./az": 144,
	"./az.js": 144,
	"./be": 145,
	"./be.js": 145,
	"./bg": 146,
	"./bg.js": 146,
	"./bn": 147,
	"./bn.js": 147,
	"./bo": 148,
	"./bo.js": 148,
	"./br": 149,
	"./br.js": 149,
	"./bs": 150,
	"./bs.js": 150,
	"./ca": 151,
	"./ca.js": 151,
	"./cs": 152,
	"./cs.js": 152,
	"./cv": 153,
	"./cv.js": 153,
	"./cy": 154,
	"./cy.js": 154,
	"./da": 155,
	"./da.js": 155,
	"./de": 158,
	"./de-at": 156,
	"./de-at.js": 156,
	"./de-ch": 157,
	"./de-ch.js": 157,
	"./de.js": 158,
	"./dv": 159,
	"./dv.js": 159,
	"./el": 160,
	"./el.js": 160,
	"./en-au": 161,
	"./en-au.js": 161,
	"./en-ca": 162,
	"./en-ca.js": 162,
	"./en-gb": 163,
	"./en-gb.js": 163,
	"./en-ie": 164,
	"./en-ie.js": 164,
	"./en-nz": 165,
	"./en-nz.js": 165,
	"./eo": 166,
	"./eo.js": 166,
	"./es": 168,
	"./es-do": 167,
	"./es-do.js": 167,
	"./es.js": 168,
	"./et": 169,
	"./et.js": 169,
	"./eu": 170,
	"./eu.js": 170,
	"./fa": 171,
	"./fa.js": 171,
	"./fi": 172,
	"./fi.js": 172,
	"./fo": 173,
	"./fo.js": 173,
	"./fr": 176,
	"./fr-ca": 174,
	"./fr-ca.js": 174,
	"./fr-ch": 175,
	"./fr-ch.js": 175,
	"./fr.js": 176,
	"./fy": 177,
	"./fy.js": 177,
	"./gd": 178,
	"./gd.js": 178,
	"./gl": 179,
	"./gl.js": 179,
	"./gom-latn": 180,
	"./gom-latn.js": 180,
	"./he": 181,
	"./he.js": 181,
	"./hi": 182,
	"./hi.js": 182,
	"./hr": 183,
	"./hr.js": 183,
	"./hu": 184,
	"./hu.js": 184,
	"./hy-am": 185,
	"./hy-am.js": 185,
	"./id": 186,
	"./id.js": 186,
	"./is": 187,
	"./is.js": 187,
	"./it": 188,
	"./it.js": 188,
	"./ja": 189,
	"./ja.js": 189,
	"./jv": 190,
	"./jv.js": 190,
	"./ka": 191,
	"./ka.js": 191,
	"./kk": 192,
	"./kk.js": 192,
	"./km": 193,
	"./km.js": 193,
	"./kn": 194,
	"./kn.js": 194,
	"./ko": 195,
	"./ko.js": 195,
	"./ky": 196,
	"./ky.js": 196,
	"./lb": 197,
	"./lb.js": 197,
	"./lo": 198,
	"./lo.js": 198,
	"./lt": 199,
	"./lt.js": 199,
	"./lv": 200,
	"./lv.js": 200,
	"./me": 201,
	"./me.js": 201,
	"./mi": 202,
	"./mi.js": 202,
	"./mk": 203,
	"./mk.js": 203,
	"./ml": 204,
	"./ml.js": 204,
	"./mr": 205,
	"./mr.js": 205,
	"./ms": 207,
	"./ms-my": 206,
	"./ms-my.js": 206,
	"./ms.js": 207,
	"./my": 208,
	"./my.js": 208,
	"./nb": 209,
	"./nb.js": 209,
	"./ne": 210,
	"./ne.js": 210,
	"./nl": 212,
	"./nl-be": 211,
	"./nl-be.js": 211,
	"./nl.js": 212,
	"./nn": 213,
	"./nn.js": 213,
	"./pa-in": 214,
	"./pa-in.js": 214,
	"./pl": 215,
	"./pl.js": 215,
	"./pt": 217,
	"./pt-br": 216,
	"./pt-br.js": 216,
	"./pt.js": 217,
	"./ro": 218,
	"./ro.js": 218,
	"./ru": 219,
	"./ru.js": 219,
	"./sd": 220,
	"./sd.js": 220,
	"./se": 221,
	"./se.js": 221,
	"./si": 222,
	"./si.js": 222,
	"./sk": 223,
	"./sk.js": 223,
	"./sl": 224,
	"./sl.js": 224,
	"./sq": 225,
	"./sq.js": 225,
	"./sr": 227,
	"./sr-cyrl": 226,
	"./sr-cyrl.js": 226,
	"./sr.js": 227,
	"./ss": 228,
	"./ss.js": 228,
	"./sv": 229,
	"./sv.js": 229,
	"./sw": 230,
	"./sw.js": 230,
	"./ta": 231,
	"./ta.js": 231,
	"./te": 232,
	"./te.js": 232,
	"./tet": 233,
	"./tet.js": 233,
	"./th": 234,
	"./th.js": 234,
	"./tl-ph": 235,
	"./tl-ph.js": 235,
	"./tlh": 236,
	"./tlh.js": 236,
	"./tr": 237,
	"./tr.js": 237,
	"./tzl": 238,
	"./tzl.js": 238,
	"./tzm": 240,
	"./tzm-latn": 239,
	"./tzm-latn.js": 239,
	"./tzm.js": 240,
	"./uk": 241,
	"./uk.js": 241,
	"./ur": 242,
	"./ur.js": 242,
	"./uz": 244,
	"./uz-latn": 243,
	"./uz-latn.js": 243,
	"./uz.js": 244,
	"./vi": 245,
	"./vi.js": 245,
	"./x-pseudo": 246,
	"./x-pseudo.js": 246,
	"./yo": 247,
	"./yo.js": 247,
	"./zh-cn": 248,
	"./zh-cn.js": 248,
	"./zh-hk": 249,
	"./zh-hk.js": 249,
	"./zh-tw": 250,
	"./zh-tw.js": 250
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;

/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
var legendsMetadata = __webpack_require__(564);

var legends;

var LEGENDS_METADATA = _.keys(legendsMetadata);
var LEGENDS_COLOR = ['category', 'choropleth'];

var LegendManager = {
  trackLegends: function (layers) {
    legends = {};

    _.each(layers.models, function (layer) {
      var legendsLayer;
      var o = {};
      if (layer.legends != null) {
        legendsLayer = layer.legends;
        _.each(LEGENDS_METADATA, function (legend) {
          var m = legendsLayer[legend];
          if (m.get('visible') === true) {
            o[legend] = m;
          }
        });
        legends[layer.id] = o;
      }
    });
  },

  getLegends: function () {
    return legends;
  },

  updateLegends: function (layerId) {
    var legendsLayer = legends[layerId];
    _.each(LEGENDS_COLOR, function (legend) {
      var m = legendsLayer[legend];
      m && m.set({visible: false});
    });
  },

  resetLegends: function (layerId) {
    var legendsLayer = legends[layerId];
    _.each(legendsLayer, function (legend) {
      legend.set({visible: true});
    });
  }
};

module.exports = LegendManager;


/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

var deepInsights = __webpack_require__(342);
var LayerStyleCollection = __webpack_require__(1047);
var EmbedIntegrations = __webpack_require__(1046);

var _ = __webpack_require__(0);
var URLStateHelper = __webpack_require__(128);
var vizJSON = window.vizJSON;
var cartoLogoOption = _.findWhere(vizJSON.overlays, {type: 'logo'});
var dashboardOpts = {
  no_cdn: false,
  cartodb_logo: cartoLogoOption !== undefined,
  renderMenu: vizJSON.options.dashboard_menu,
  share_urls: true,
  authToken: window.authTokens,
  layerSelectorEnabled: true,
  mapzenApiKey: window.mapzenApiKey
};
var stateJSON = window.stateJSON;
var layersData = window.layersData;

var stateFromURL = URLStateHelper.getStateFromCurrentURL();
if (stateFromURL && !_.isEmpty(stateFromURL)) {
  _.extend(dashboardOpts, {
    state: stateFromURL
  });
} else if (stateJSON && stateJSON !== '{}') {
  _.extend(dashboardOpts, {
    state: stateJSON
  });
}

var layerStyleCollection = new LayerStyleCollection();
layerStyleCollection.resetByLayersData(layersData);

deepInsights.createDashboard('#dashboard', vizJSON, dashboardOpts, function (error, dashboard) {
  if (error) {
    console.error('Dashboard has some errors:', error);
  }

  var map = dashboard.getMap().map;
  var scrollwheel = vizJSON.options.scrollwheel;
  var method = scrollwheel ? 'enableScrollWheel' : 'disableScrollWheel';
  map && map[method] && map[method]();

  var embedIntegrations = new EmbedIntegrations({
    deepInsightsDashboard: dashboard,
    layerStyleCollection: layerStyleCollection
  });

  window.embedIntegrations = embedIntegrations;
});

window.layerStyleCollection = layerStyleCollection;


/***/ }),

/***/ 368:
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 368;

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);

module.exports = function checkAndBuildRequiredOpts (actualOpts, requiredOpts, context) {
  if (requiredOpts === void 0) {
    throw new Error('Opts are required');
  }

  _.each(requiredOpts, function (item) {
    if (actualOpts[item] === void 0) throw new Error(item + ' is required');
    context['_' + item] = actualOpts[item];
  }, context);
};


/***/ }),

/***/ 564:
/***/ (function(module, exports) {

var LEGENDS_METADATA = {
  bubble: {
    legendType: 'size'
  },
  category: {
    legendType: 'color'
  },
  choropleth: {
    legendType: 'color'
  },
  custom: {
    legendType: 'color'
  },
  custom_choropleth: {
    legendType: 'color'
  }
};

module.exports = LEGENDS_METADATA;


/***/ }),

/***/ 891:
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 891;

/***/ }),

/***/ 894:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 895:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[1387]);


// WEBPACK FOOTER //
// 4.9.54/javascripts/builder_embed.js